<template>
  <UiSidebarCard title="Code promotionnel / carte cadeau">
    <template #picto>
      <SvgPictoCoupons />
    </template>
    <CartApplyCouponForm />
  </UiSidebarCard>
</template>
